import { render, staticRenderFns } from "./ReplacementZJList.vue?vue&type=template&id=36e288b7&scoped=true&"
import script from "./ReplacementZJList.vue?vue&type=script&lang=js&"
export * from "./ReplacementZJList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e288b7",
  null
  
)

export default component.exports